import React, { useEffect, useState, useContext } from 'react'
import WorkerHeader from "./worker_header";
import Skillsbtn from "./Skillsbtn";
import refrence from "./reference";
import { useSelector, useDispatch } from 'react-redux';
//import language context
import { LanguageContext } from '../global/languageContext';
// Caution: before you start going through, I used icons as pure SVG format thats why the code is a bit bulky, always close SVG bracket to maintain code readability.
import { getProfile, cv_loading, getAllMyCv, resume_step_jump_function } from '../../Redux/ActionCreator';
import LoaderModal from '../../components/LoaderModal';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

function WorkerProfile(props) {
  const navigate = useNavigate();
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const userPics = useSelector(prev => prev.userInfo);
  const savedResume = useSelector(e => e.saved_cv);
  const res = useSelector(e => e.last_resume);
  const details = savedResume.message;
	const [ picLink, setPicsLink ] = useState('');

	const profile = useSelector(prev => prev.profile);
	const dispatch = useDispatch();

	useEffect(() => {
    dispatch(cv_loading(true));
    dispatch(resume_step_jump_function(0));
		if (userPics.user !== null) {
      setPicsLink(userPics.user.profile_pics);
    }

    if (savedResume.message === null || savedResume.message.length === 0) {
      dispatch(getAllMyCv(localStorage.getItem('token')));
    }

		// const token = localStorage.getItem('token');
		// dispatch(postUserProfile(token));
    console.log("Called!!!!!", profile.message)
		if (profile.isloading === false && (profile.message === undefined || profile.message === null)) {
			let token = localStorage.getItem("token");
      dispatch(getProfile(token));
		}
	}, [ userPics, profile ]);

  const handleResumePreview = () => {
    const resume = details[details.length - 1];
    navigate(`/resume/${resume._id}?id=${resume.pdfId}&payment_intent_client_secret=${resume.Secret}&stat=cannot update`)
  }

  return (
      <>{savedResume.message !== null && profile.message !== null ? 
        <div className="px-[2.5%] w-full h-full overflow-y-scroll mx-auto">
        <h1 className=" font-medium text-xl tablet:text-4xl text-[#626060]">
          My Profile
        </h1>
        <div className="my-4 w-full h-full bg-[#FDFCFD]  rounded-2xl flex flex-col items-center">
          {/* top purple header of page  */}
          <WorkerHeader onClick={handleResumePreview} />

          {/* bottom white content of page  */}
          <div className=" w-[80%] flex flex-col items-center my-9 gap-9">
            {/* Divider line  */}
            <hr className=" bg-[#E9E9FB] w-full" />

            {/* About page  */}
            <div className="flex flex-col tablet:flex-row gap-10 w-full">
              <div className="bg-white rounded-xl border border-[#D2D4F8] p-5 w-full tablet:w-[70%] flex justify-between">
                {/* content  */}
                <div className="w-[90%]">
                  <h1 className="text-[#5843BD] font-semibold text-base">
                    About
                  </h1>
                  <p className=" text-sm font-normal text-[#666666]">
                    {profile.message === null ? null : profile.message?.About}
                  </p>
                </div>

                {/* edit icon  */}
                <div onClick={() => navigate("/user/profile/update/about")}>
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                      fill="#FF6633"
                    />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                {/* info  */}
                <div className="bg-white rounded-xl border border-[#D2D4F8] p-5">
                  <h1 className="text-[#5843BD] font-semibold text-base">Info</h1>
                  <p className=" text-sm font-normal text-[#666666]">
                    {profile.message?.Years_of_experience} years Experience <br/> {profile.message === null ? null : profile.message.Education[0]?.Course}
                  </p>
                </div>
                {/* location  */}
                <div className="bg-white rounded-xl border border-[#D2D4F8] p-5">
                  <h1 className="text-[#5843BD] font-semibold text-base">
                    Location
                  </h1>
                  <p className=" text-sm font-normal text-[#666666]">
                  {profile.message === null ? null : profile.message?.Address}
                  </p>
                </div>
              </div>
            </div>

            {/* Divider line */}
            <hr className=" bg-[#E9E9FB] w-full" />

            {/* Weekly availability  */}
            {/* <div className="w-full flex justify-between"> */}
              {/* LHS content  */}
{/*               <div className="w-[90%] flex flex-col gap-4">
                <h1 className=" font-semibold text-base text-[#5843BD]">
                  Weekly Availability
                </h1>
                <div className=" font-medium text-base text-[#666666]">
                  <p>Weekdays</p>
                  <p>10:00am - 5:00pm</p>
                </div>
              </div> */}

              {/* RHS icon  */}
              {/* <div>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9971 11.0029C19.7319 11.0029 19.4775 11.1082 19.29 11.2958C19.1024 11.4833 18.9971 11.7377 18.9971 12.0029V18.0029C18.9971 18.2681 18.8917 18.5224 18.7042 18.71C18.5166 18.8975 18.2623 19.0029 17.9971 19.0029H3.99707C3.73185 19.0029 3.4775 18.8975 3.28996 18.71C3.10243 18.5224 2.99707 18.2681 2.99707 18.0029V4.00287C2.99707 3.73765 3.10243 3.4833 3.28996 3.29576C3.4775 3.10823 3.73185 3.00287 3.99707 3.00287H9.99707C10.2623 3.00287 10.5166 2.89751 10.7042 2.70998C10.8917 2.52244 10.9971 2.26809 10.9971 2.00287C10.9971 1.73765 10.8917 1.4833 10.7042 1.29576C10.5166 1.10823 10.2623 1.00287 9.99707 1.00287H3.99707C3.20142 1.00287 2.43836 1.31894 1.87575 1.88155C1.31314 2.44416 0.99707 3.20722 0.99707 4.00287V18.0029C0.99707 18.7985 1.31314 19.5616 1.87575 20.1242C2.43836 20.6868 3.20142 21.0029 3.99707 21.0029H17.9971C18.7927 21.0029 19.5558 20.6868 20.1184 20.1242C20.681 19.5616 20.9971 18.7985 20.9971 18.0029V12.0029C20.9971 11.7377 20.8917 11.4833 20.7042 11.2958C20.5166 11.1082 20.2623 11.0029 19.9971 11.0029ZM4.99707 11.7629V16.0029C4.99707 16.2681 5.10243 16.5224 5.28996 16.71C5.4775 16.8975 5.73185 17.0029 5.99707 17.0029H10.2371C10.3687 17.0036 10.4991 16.9784 10.621 16.9286C10.7428 16.8789 10.8536 16.8055 10.9471 16.7129L17.8671 9.78287L20.7071 7.00287C20.8008 6.90991 20.8752 6.7993 20.926 6.67745C20.9767 6.55559 21.0029 6.42488 21.0029 6.29287C21.0029 6.16086 20.9767 6.03015 20.926 5.90829C20.8752 5.78643 20.8008 5.67583 20.7071 5.58287L16.4671 1.29287C16.3741 1.19914 16.2635 1.12475 16.1416 1.07398C16.0198 1.02321 15.8891 0.99707 15.7571 0.99707C15.6251 0.99707 15.4944 1.02321 15.3725 1.07398C15.2506 1.12475 15.14 1.19914 15.0471 1.29287L12.2271 4.12287L5.28707 11.0529C5.19439 11.1463 5.12106 11.2571 5.0713 11.379C5.02153 11.5008 4.99631 11.6313 4.99707 11.7629ZM15.7571 3.41287L18.5871 6.24287L17.1671 7.66287L14.3371 4.83287L15.7571 3.41287ZM6.99707 12.1729L12.9271 6.24287L15.7571 9.07287L9.82707 15.0029H6.99707V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div> */}

            {/* Your skills  */}
            <div className="w-full flex justify-between relative">
              {/* LHS content  */}
              <div className="w-[90%]">
                <h1 className="font-semibold text-base text-[#5843BD]">
                  Your skills
                </h1>

                {/* Skills icon sha, woo  */}
                <div className=" justify-content-start w-full mb-4 text-start">
                  {profile.message.Skills?.map((anything) => (
                    <Skillsbtn btntxt={anything.value} key={anything._id} />
                  ))}
                </div>
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/skills")}>
                <svg
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9941 11.0029C19.7289 11.0029 19.4746 11.1082 19.287 11.2958C19.0995 11.4833 18.9941 11.7377 18.9941 12.0029V18.0029C18.9941 18.2681 18.8888 18.5224 18.7012 18.71C18.5137 18.8975 18.2594 19.0029 17.9941 19.0029H3.99414C3.72892 19.0029 3.47457 18.8975 3.28703 18.71C3.0995 18.5224 2.99414 18.2681 2.99414 18.0029V4.00287C2.99414 3.73765 3.0995 3.4833 3.28703 3.29576C3.47457 3.10823 3.72892 3.00287 3.99414 3.00287H9.99414C10.2594 3.00287 10.5137 2.89751 10.7012 2.70998C10.8888 2.52244 10.9941 2.26809 10.9941 2.00287C10.9941 1.73765 10.8888 1.4833 10.7012 1.29576C10.5137 1.10823 10.2594 1.00287 9.99414 1.00287H3.99414C3.19849 1.00287 2.43543 1.31894 1.87282 1.88155C1.31021 2.44416 0.994141 3.20722 0.994141 4.00287V18.0029C0.994141 18.7985 1.31021 19.5616 1.87282 20.1242C2.43543 20.6868 3.19849 21.0029 3.99414 21.0029H17.9941C18.7898 21.0029 19.5529 20.6868 20.1155 20.1242C20.6781 19.5616 20.9941 18.7985 20.9941 18.0029V12.0029C20.9941 11.7377 20.8888 11.4833 20.7012 11.2958C20.5137 11.1082 20.2594 11.0029 19.9941 11.0029ZM4.99414 11.7629V16.0029C4.99414 16.2681 5.0995 16.5224 5.28703 16.71C5.47457 16.8975 5.72892 17.0029 5.99414 17.0029H10.2341C10.3657 17.0036 10.4962 16.9784 10.618 16.9286C10.7399 16.8789 10.8507 16.8055 10.9441 16.7129L17.8641 9.78287L20.7041 7.00287C20.7979 6.90991 20.8723 6.7993 20.923 6.67745C20.9738 6.55559 20.9999 6.42488 20.9999 6.29287C20.9999 6.16086 20.9738 6.03015 20.923 5.90829C20.8723 5.78643 20.7979 5.67583 20.7041 5.58287L16.4641 1.29287C16.3712 1.19914 16.2606 1.12475 16.1387 1.07398C16.0169 1.02321 15.8862 0.99707 15.7541 0.99707C15.6221 0.99707 15.4914 1.02321 15.3696 1.07398C15.2477 1.12475 15.1371 1.19914 15.0441 1.29287L12.2241 4.12287L5.28414 11.0529C5.19146 11.1463 5.11813 11.2571 5.06837 11.379C5.0186 11.5008 4.99338 11.6313 4.99414 11.7629ZM15.7541 3.41287L18.5841 6.24287L17.1641 7.66287L14.3341 4.83287L15.7541 3.41287ZM6.99414 12.1729L12.9241 6.24287L15.7541 9.07287L9.82414 15.0029H6.99414V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>

            {/* Divider line */}
            {/* margin top to compensate for absolute above  */}
            <hr className=" bg-[#E9E9FB] w-full mt-24" />

            {/* Work Experience  */}
            <div className="w-full flex justify-between">
              {/* LHS content  */}
              <div className="w-[90%]">
                <h1 className="font-semibold text-base text-[#5843BD] mb-4">
                  Work Experience
                </h1>
                {/* Content */}
                {
                  profile.message?.Experience?.map((data, key) => (
                    <div className="w-full flex flex-col gap-6 py-4" key={key} >
                  {/* up content  */}
                  <div className="flex flex-col tablet:flex-row gap-8 w-full justify-between">
                    {/* year and kini  */}
                      <ul className=" w-full tablet:w-[40%] tablet:list-disc text-xs">
                        <li className=" font-semibold text-sm mb-2">2022</li>
                        <li>{data?.Where_i_worked}</li>
                        {/* <li>{data.Where_i_worked_location}</li> */}
                      </ul>

                      {/* details side  */}
                      <ul className=" w-full tablet:w-[60%] tablet:list-disc text-xs">
                        <li className=" font-semibold text-sm mb-2">
                          {data?.My_job_title}
                        </li>
                        {Array.isArray(data.Day_to_day_work) == true ? 
                        <>
                        {data.Day_to_day_work?.map((exp, key) => (
                          <li key={key}>
                            {exp.slice(1, exp.length)}
                          </li>
                        ))}
                        </> : <>
                          <li key={key}>
                            {data?.Day_to_day_work}
                          </li>
                        </>
                        }
                      </ul>
                    </div>
                  </div>
                  ))
                }
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/experience")}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9971 11.0029C19.7319 11.0029 19.4775 11.1082 19.29 11.2958C19.1024 11.4833 18.9971 11.7377 18.9971 12.0029V18.0029C18.9971 18.2681 18.8917 18.5224 18.7042 18.71C18.5166 18.8975 18.2623 19.0029 17.9971 19.0029H3.99707C3.73185 19.0029 3.4775 18.8975 3.28996 18.71C3.10243 18.5224 2.99707 18.2681 2.99707 18.0029V4.00287C2.99707 3.73765 3.10243 3.4833 3.28996 3.29576C3.4775 3.10823 3.73185 3.00287 3.99707 3.00287H9.99707C10.2623 3.00287 10.5166 2.89751 10.7042 2.70998C10.8917 2.52244 10.9971 2.26809 10.9971 2.00287C10.9971 1.73765 10.8917 1.4833 10.7042 1.29576C10.5166 1.10823 10.2623 1.00287 9.99707 1.00287H3.99707C3.20142 1.00287 2.43836 1.31894 1.87575 1.88155C1.31314 2.44416 0.99707 3.20722 0.99707 4.00287V18.0029C0.99707 18.7985 1.31314 19.5616 1.87575 20.1242C2.43836 20.6868 3.20142 21.0029 3.99707 21.0029H17.9971C18.7927 21.0029 19.5558 20.6868 20.1184 20.1242C20.681 19.5616 20.9971 18.7985 20.9971 18.0029V12.0029C20.9971 11.7377 20.8917 11.4833 20.7042 11.2958C20.5166 11.1082 20.2623 11.0029 19.9971 11.0029ZM4.99707 11.7629V16.0029C4.99707 16.2681 5.10243 16.5224 5.28996 16.71C5.4775 16.8975 5.73185 17.0029 5.99707 17.0029H10.2371C10.3687 17.0036 10.4991 16.9784 10.621 16.9286C10.7428 16.8789 10.8536 16.8055 10.9471 16.7129L17.8671 9.78287L20.7071 7.00287C20.8008 6.90991 20.8752 6.7993 20.926 6.67745C20.9767 6.55559 21.0029 6.42488 21.0029 6.29287C21.0029 6.16086 20.9767 6.03015 20.926 5.90829C20.8752 5.78643 20.8008 5.67583 20.7071 5.58287L16.4671 1.29287C16.3741 1.19914 16.2635 1.12475 16.1416 1.07398C16.0198 1.02321 15.8891 0.99707 15.7571 0.99707C15.6251 0.99707 15.4944 1.02321 15.3725 1.07398C15.2506 1.12475 15.14 1.19914 15.0471 1.29287L12.2271 4.12287L5.28707 11.0529C5.19439 11.1463 5.12106 11.2571 5.0713 11.379C5.02153 11.5008 4.99631 11.6313 4.99707 11.7629ZM15.7571 3.41287L18.5871 6.24287L17.1671 7.66287L14.3371 4.83287L15.7571 3.41287ZM6.99707 12.1729L12.9271 6.24287L15.7571 9.07287L9.82707 15.0029H6.99707V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>

            {/* View more WE  */}
{/*             <div>
              <button className=" font-normal text-base text-[#5843BD] flex justify-center items-center gap-2">
                View more{" "}
                <span>
                  <svg
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.70734 7.7071C7.51981 7.89457 7.26551 7.99989 7.00034 7.99989C6.73518 7.99989 6.48087 7.89457 6.29334 7.7071L0.636343 2.0501C0.540833 1.95785 0.464651 1.84751 0.412242 1.7255C0.359833 1.6035 0.332246 1.47228 0.331092 1.3395C0.329939 1.20672 0.355241 1.07504 0.405521 0.952145C0.455802 0.829249 0.530055 0.717596 0.623948 0.623704C0.717841 0.529811 0.829492 0.455558 0.952389 0.405277C1.07529 0.354996 1.20696 0.329694 1.33974 0.330848C1.47252 0.332002 1.60374 0.359588 1.72575 0.411997C1.84775 0.464406 1.9581 0.540588 2.05034 0.636098L7.00034 5.5861L11.9503 0.636098C12.1389 0.45394 12.3915 0.353146 12.6537 0.355424C12.9159 0.357703 13.1668 0.462872 13.3522 0.64828C13.5376 0.833688 13.6427 1.0845 13.645 1.3467C13.6473 1.60889 13.5465 1.8615 13.3643 2.0501L7.70734 7.7071Z"
                      fill="#5843BD"
                    />
                  </svg>
                </span>
              </button>
            </div> */}

            {/* Divider line  */}
            <hr className=" bg-[#E9E9FB] w-full" />

            {/* Education  */}
            <div className="w-full flex justify-between">
              {/* LHS content  */}
              <div className="w-[90%]">
                <h1 className="font-semibold text-base text-[#5843BD] mb-4">
                  Education
                </h1>
                {/* Content */}
                {profile.message.Education?.map((edu, key) => (
                  <div className="w-full flex flex-col gap-6 py-3" key={key}>
                    {/* up content  */}
                    <div className="flex flex-col tablet:flex-row gap-8 w-full justify-between">
                      {/* year and kini  */}
                      <ul className="w-full tablet:w-[40%] tablet:list-disc text-xs">
                        
                          {edu.Start_date === null ? <li className=" font-semibold text-sm mb-2">{data?.End_date}</li> : <li className=" font-semibold text-sm mb-2">{edu?.Start_date}-{edu?.End_date}</li> }
                        
                      </ul>

                      {/* details side  */}
                      <ul className=" w-full tablet:w-[60%] tablet:list-disc text-xs">
                        <li className=" font-semibold text-sm mb-2">
                          {edu.Degree}
                        </li>
                        <li>{edu?.School}</li>
                      </ul>
                    </div>
                  </div>
                ))}
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/education")}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9971 11.0029C19.7319 11.0029 19.4775 11.1082 19.29 11.2958C19.1024 11.4833 18.9971 11.7377 18.9971 12.0029V18.0029C18.9971 18.2681 18.8917 18.5224 18.7042 18.71C18.5166 18.8975 18.2623 19.0029 17.9971 19.0029H3.99707C3.73185 19.0029 3.4775 18.8975 3.28996 18.71C3.10243 18.5224 2.99707 18.2681 2.99707 18.0029V4.00287C2.99707 3.73765 3.10243 3.4833 3.28996 3.29576C3.4775 3.10823 3.73185 3.00287 3.99707 3.00287H9.99707C10.2623 3.00287 10.5166 2.89751 10.7042 2.70998C10.8917 2.52244 10.9971 2.26809 10.9971 2.00287C10.9971 1.73765 10.8917 1.4833 10.7042 1.29576C10.5166 1.10823 10.2623 1.00287 9.99707 1.00287H3.99707C3.20142 1.00287 2.43836 1.31894 1.87575 1.88155C1.31314 2.44416 0.99707 3.20722 0.99707 4.00287V18.0029C0.99707 18.7985 1.31314 19.5616 1.87575 20.1242C2.43836 20.6868 3.20142 21.0029 3.99707 21.0029H17.9971C18.7927 21.0029 19.5558 20.6868 20.1184 20.1242C20.681 19.5616 20.9971 18.7985 20.9971 18.0029V12.0029C20.9971 11.7377 20.8917 11.4833 20.7042 11.2958C20.5166 11.1082 20.2623 11.0029 19.9971 11.0029ZM4.99707 11.7629V16.0029C4.99707 16.2681 5.10243 16.5224 5.28996 16.71C5.4775 16.8975 5.73185 17.0029 5.99707 17.0029H10.2371C10.3687 17.0036 10.4991 16.9784 10.621 16.9286C10.7428 16.8789 10.8536 16.8055 10.9471 16.7129L17.8671 9.78287L20.7071 7.00287C20.8008 6.90991 20.8752 6.7993 20.926 6.67745C20.9767 6.55559 21.0029 6.42488 21.0029 6.29287C21.0029 6.16086 20.9767 6.03015 20.926 5.90829C20.8752 5.78643 20.8008 5.67583 20.7071 5.58287L16.4671 1.29287C16.3741 1.19914 16.2635 1.12475 16.1416 1.07398C16.0198 1.02321 15.8891 0.99707 15.7571 0.99707C15.6251 0.99707 15.4944 1.02321 15.3725 1.07398C15.2506 1.12475 15.14 1.19914 15.0471 1.29287L12.2271 4.12287L5.28707 11.0529C5.19439 11.1463 5.12106 11.2571 5.0713 11.379C5.02153 11.5008 4.99631 11.6313 4.99707 11.7629ZM15.7571 3.41287L18.5871 6.24287L17.1671 7.66287L14.3371 4.83287L15.7571 3.41287ZM6.99707 12.1729L12.9271 6.24287L15.7571 9.07287L9.82707 15.0029H6.99707V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>

            {/* View more Education  */}
{/*             <div>
              <button className=" font-normal text-base text-[#5843BD] flex justify-center items-center gap-2">
                View more{" "}
                <span>
                  <svg
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.70734 7.7071C7.51981 7.89457 7.26551 7.99989 7.00034 7.99989C6.73518 7.99989 6.48087 7.89457 6.29334 7.7071L0.636343 2.0501C0.540833 1.95785 0.464651 1.84751 0.412242 1.7255C0.359833 1.6035 0.332246 1.47228 0.331092 1.3395C0.329939 1.20672 0.355241 1.07504 0.405521 0.952145C0.455802 0.829249 0.530055 0.717596 0.623948 0.623704C0.717841 0.529811 0.829492 0.455558 0.952389 0.405277C1.07529 0.354996 1.20696 0.329694 1.33974 0.330848C1.47252 0.332002 1.60374 0.359588 1.72575 0.411997C1.84775 0.464406 1.9581 0.540588 2.05034 0.636098L7.00034 5.5861L11.9503 0.636098C12.1389 0.45394 12.3915 0.353146 12.6537 0.355424C12.9159 0.357703 13.1668 0.462872 13.3522 0.64828C13.5376 0.833688 13.6427 1.0845 13.645 1.3467C13.6473 1.60889 13.5465 1.8615 13.3643 2.0501L7.70734 7.7071Z"
                      fill="#5843BD"
                    />
                  </svg>
                </span>
              </button>
            </div> */}

            {/* Soft Skills  */}
            <div className="w-full flex justify-between relative">
              {/* LHS content  */}
              <div className="w-[90%]">
                <h1 className="font-semibold text-base text-[#5843BD]">
                  Soft Skills
                </h1>

                {/* Skills icon sha, woo  */}
                <div className=" justify-content-start w-full mb-4 text-start">
                  {profile.message?.Soft_skills?.map((anything) => (
                    <Skillsbtn btntxt={anything.value} key={anything._id} />
                  ))}
                </div>
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/skills")}>
                <svg
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9941 11.0029C19.7289 11.0029 19.4746 11.1082 19.287 11.2958C19.0995 11.4833 18.9941 11.7377 18.9941 12.0029V18.0029C18.9941 18.2681 18.8888 18.5224 18.7012 18.71C18.5137 18.8975 18.2594 19.0029 17.9941 19.0029H3.99414C3.72892 19.0029 3.47457 18.8975 3.28703 18.71C3.0995 18.5224 2.99414 18.2681 2.99414 18.0029V4.00287C2.99414 3.73765 3.0995 3.4833 3.28703 3.29576C3.47457 3.10823 3.72892 3.00287 3.99414 3.00287H9.99414C10.2594 3.00287 10.5137 2.89751 10.7012 2.70998C10.8888 2.52244 10.9941 2.26809 10.9941 2.00287C10.9941 1.73765 10.8888 1.4833 10.7012 1.29576C10.5137 1.10823 10.2594 1.00287 9.99414 1.00287H3.99414C3.19849 1.00287 2.43543 1.31894 1.87282 1.88155C1.31021 2.44416 0.994141 3.20722 0.994141 4.00287V18.0029C0.994141 18.7985 1.31021 19.5616 1.87282 20.1242C2.43543 20.6868 3.19849 21.0029 3.99414 21.0029H17.9941C18.7898 21.0029 19.5529 20.6868 20.1155 20.1242C20.6781 19.5616 20.9941 18.7985 20.9941 18.0029V12.0029C20.9941 11.7377 20.8888 11.4833 20.7012 11.2958C20.5137 11.1082 20.2594 11.0029 19.9941 11.0029ZM4.99414 11.7629V16.0029C4.99414 16.2681 5.0995 16.5224 5.28703 16.71C5.47457 16.8975 5.72892 17.0029 5.99414 17.0029H10.2341C10.3657 17.0036 10.4962 16.9784 10.618 16.9286C10.7399 16.8789 10.8507 16.8055 10.9441 16.7129L17.8641 9.78287L20.7041 7.00287C20.7979 6.90991 20.8723 6.7993 20.923 6.67745C20.9738 6.55559 20.9999 6.42488 20.9999 6.29287C20.9999 6.16086 20.9738 6.03015 20.923 5.90829C20.8723 5.78643 20.7979 5.67583 20.7041 5.58287L16.4641 1.29287C16.3712 1.19914 16.2606 1.12475 16.1387 1.07398C16.0169 1.02321 15.8862 0.99707 15.7541 0.99707C15.6221 0.99707 15.4914 1.02321 15.3696 1.07398C15.2477 1.12475 15.1371 1.19914 15.0441 1.29287L12.2241 4.12287L5.28414 11.0529C5.19146 11.1463 5.11813 11.2571 5.06837 11.379C5.0186 11.5008 4.99338 11.6313 4.99414 11.7629ZM15.7541 3.41287L18.5841 6.24287L17.1641 7.66287L14.3341 4.83287L15.7541 3.41287ZM6.99414 12.1729L12.9241 6.24287L15.7541 9.07287L9.82414 15.0029H6.99414V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>

            {/* Divider line */}
            {/* margin top to compensate for absolute above  */}
            <hr className=" bg-[#E9E9FB] w-full mt-24" />

            {/* Hobbies and interest  */}
            <div className="w-full flex justify-between relative">
              {/* LHS content  */}
              <div className="w-[90%]">
                <h1 className="font-semibold text-base text-[#5843BD]">
                  Professional Interests
                </h1>

                {/* hobbies icon sha, woo  */}
                <div className=" justify-content-start w-full mb-4 text-start">
                  {profile.message?.Interest?.map((anything, key) => (
                    <Skillsbtn btntxt={anything} key={key} />
                  ))}
                </div>
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/about")}>
                <svg
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9941 11.0029C19.7289 11.0029 19.4746 11.1082 19.287 11.2958C19.0995 11.4833 18.9941 11.7377 18.9941 12.0029V18.0029C18.9941 18.2681 18.8888 18.5224 18.7012 18.71C18.5137 18.8975 18.2594 19.0029 17.9941 19.0029H3.99414C3.72892 19.0029 3.47457 18.8975 3.28703 18.71C3.0995 18.5224 2.99414 18.2681 2.99414 18.0029V4.00287C2.99414 3.73765 3.0995 3.4833 3.28703 3.29576C3.47457 3.10823 3.72892 3.00287 3.99414 3.00287H9.99414C10.2594 3.00287 10.5137 2.89751 10.7012 2.70998C10.8888 2.52244 10.9941 2.26809 10.9941 2.00287C10.9941 1.73765 10.8888 1.4833 10.7012 1.29576C10.5137 1.10823 10.2594 1.00287 9.99414 1.00287H3.99414C3.19849 1.00287 2.43543 1.31894 1.87282 1.88155C1.31021 2.44416 0.994141 3.20722 0.994141 4.00287V18.0029C0.994141 18.7985 1.31021 19.5616 1.87282 20.1242C2.43543 20.6868 3.19849 21.0029 3.99414 21.0029H17.9941C18.7898 21.0029 19.5529 20.6868 20.1155 20.1242C20.6781 19.5616 20.9941 18.7985 20.9941 18.0029V12.0029C20.9941 11.7377 20.8888 11.4833 20.7012 11.2958C20.5137 11.1082 20.2594 11.0029 19.9941 11.0029ZM4.99414 11.7629V16.0029C4.99414 16.2681 5.0995 16.5224 5.28703 16.71C5.47457 16.8975 5.72892 17.0029 5.99414 17.0029H10.2341C10.3657 17.0036 10.4962 16.9784 10.618 16.9286C10.7399 16.8789 10.8507 16.8055 10.9441 16.7129L17.8641 9.78287L20.7041 7.00287C20.7979 6.90991 20.8723 6.7993 20.923 6.67745C20.9738 6.55559 20.9999 6.42488 20.9999 6.29287C20.9999 6.16086 20.9738 6.03015 20.923 5.90829C20.8723 5.78643 20.7979 5.67583 20.7041 5.58287L16.4641 1.29287C16.3712 1.19914 16.2606 1.12475 16.1387 1.07398C16.0169 1.02321 15.8862 0.99707 15.7541 0.99707C15.6221 0.99707 15.4914 1.02321 15.3696 1.07398C15.2477 1.12475 15.1371 1.19914 15.0441 1.29287L12.2241 4.12287L5.28414 11.0529C5.19146 11.1463 5.11813 11.2571 5.06837 11.379C5.0186 11.5008 4.99338 11.6313 4.99414 11.7629ZM15.7541 3.41287L18.5841 6.24287L17.1641 7.66287L14.3341 4.83287L15.7541 3.41287ZM6.99414 12.1729L12.9241 6.24287L15.7541 9.07287L9.82414 15.0029H6.99414V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>

            {/* Refrence  */}
            <div className="w-full flex justify-between mt-24">
              {/* LHS content  */}
              <div className="w-[90%] pb-10">
                <h1 className="font-semibold text-base text-[#5843BD] mb-4">
                  Reference
                </h1>
                {/* Content */}
                {
                  profile.message?.Reference?.map((ref, key) => (
                    <div className="w-full flex flex-col gap-6">
                      {/* up content  */}
                      <div className="flex gap-8 w-full justify-between">
                        {/* details side  */}
                        <ul className=" text-xs">
                          <li className=" font-semibold text-sm mb-2">{ref.Reference_person_name}</li>
                          <li>
                            <p>{ref?.Referencee_job_title}</p>
                            <p>{ref?.Reference_phone_number}</p>
                            <p>{ref?.Reference_email}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))
                }
              </div>

              {/* RHS icon  */}
              <div onClick={() => navigate("/user/profile/update/reference")}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9971 11.0029C19.7319 11.0029 19.4775 11.1082 19.29 11.2958C19.1024 11.4833 18.9971 11.7377 18.9971 12.0029V18.0029C18.9971 18.2681 18.8917 18.5224 18.7042 18.71C18.5166 18.8975 18.2623 19.0029 17.9971 19.0029H3.99707C3.73185 19.0029 3.4775 18.8975 3.28996 18.71C3.10243 18.5224 2.99707 18.2681 2.99707 18.0029V4.00287C2.99707 3.73765 3.10243 3.4833 3.28996 3.29576C3.4775 3.10823 3.73185 3.00287 3.99707 3.00287H9.99707C10.2623 3.00287 10.5166 2.89751 10.7042 2.70998C10.8917 2.52244 10.9971 2.26809 10.9971 2.00287C10.9971 1.73765 10.8917 1.4833 10.7042 1.29576C10.5166 1.10823 10.2623 1.00287 9.99707 1.00287H3.99707C3.20142 1.00287 2.43836 1.31894 1.87575 1.88155C1.31314 2.44416 0.99707 3.20722 0.99707 4.00287V18.0029C0.99707 18.7985 1.31314 19.5616 1.87575 20.1242C2.43836 20.6868 3.20142 21.0029 3.99707 21.0029H17.9971C18.7927 21.0029 19.5558 20.6868 20.1184 20.1242C20.681 19.5616 20.9971 18.7985 20.9971 18.0029V12.0029C20.9971 11.7377 20.8917 11.4833 20.7042 11.2958C20.5166 11.1082 20.2623 11.0029 19.9971 11.0029ZM4.99707 11.7629V16.0029C4.99707 16.2681 5.10243 16.5224 5.28996 16.71C5.4775 16.8975 5.73185 17.0029 5.99707 17.0029H10.2371C10.3687 17.0036 10.4991 16.9784 10.621 16.9286C10.7428 16.8789 10.8536 16.8055 10.9471 16.7129L17.8671 9.78287L20.7071 7.00287C20.8008 6.90991 20.8752 6.7993 20.926 6.67745C20.9767 6.55559 21.0029 6.42488 21.0029 6.29287C21.0029 6.16086 20.9767 6.03015 20.926 5.90829C20.8752 5.78643 20.8008 5.67583 20.7071 5.58287L16.4671 1.29287C16.3741 1.19914 16.2635 1.12475 16.1416 1.07398C16.0198 1.02321 15.8891 0.99707 15.7571 0.99707C15.6251 0.99707 15.4944 1.02321 15.3725 1.07398C15.2506 1.12475 15.14 1.19914 15.0471 1.29287L12.2271 4.12287L5.28707 11.0529C5.19439 11.1463 5.12106 11.2571 5.0713 11.379C5.02153 11.5008 4.99631 11.6313 4.99707 11.7629ZM15.7571 3.41287L18.5871 6.24287L17.1671 7.66287L14.3371 4.83287L15.7571 3.41287ZM6.99707 12.1729L12.9271 6.24287L15.7571 9.07287L9.82707 15.0029H6.99707V12.1729Z"
                    fill="#FF6633"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <Outlet />
      </div> : <div><LoaderModal text="Fetching profile" /></div>}</>
  );
}

export default WorkerProfile;